import { render, staticRenderFns } from "./materialForm.vue?vue&type=template&id=50c7d07e&scoped=true"
import script from "./materialForm.vue?vue&type=script&lang=js"
export * from "./materialForm.vue?vue&type=script&lang=js"
import style0 from "./materialForm.vue?vue&type=style&index=0&id=50c7d07e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c7d07e",
  null
  
)

export default component.exports